import { useQuery } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";

import { getEventsListingForGoPlay } from "../../services/search";

type UseQueryEventsListingResponse = {
  items: any[];
  meta: { [key: string]: number };
};

type UseQueryEventsListingResult = {
  eventsListingResult: UseQueryEventsListingResponse | undefined;
  isEventsListingResultLoading: boolean;
  isEventListingHasError: boolean;
};

export const useQueryEventsListing = (minDate?: string, maxDate?: string): UseQueryEventsListingResult => {
  const { i18n } = useTranslation();

  const {
    data: eventsListingResult,
    isLoading: isEventsListingResultLoading,
    isError: isEventListingHasError,
  } = useQuery<UseQueryEventsListingResponse>({
    queryKey: ["Explore", "GoPlay", i18n.language, minDate, maxDate],
    queryFn: async () => await getEventsListingForGoPlay(minDate, maxDate),
  });

  return { eventsListingResult, isEventsListingResultLoading, isEventListingHasError };
};
